import { DateTime } from 'luxon';
const tzString = (abbreviated = false): string => {
  return DateTime.local({
    locale: DateTime.local().locale ?? 'en-US',
  }).toFormat(abbreviated ? 'ZZZZ' : 'ZZZZZ');
};

export default tzString;
